<template>
  <el-select-tree
    @change="selectOne"
    :data="dataList"
    :props="treeProps"
    v-model="selectID"
    :disabled="disabled"
    :default-expand-all="true"
    :check-strictly="true"
    placeholder="默认"></el-select-tree>
</template>

<script>
  import {treeDataTranslate} from '@/utils'

  export default {
    data() {
      return {
        selectID: this.menuId,
        treeProps: {
          value: 'id',
          label: 'name',
          children: 'children'
        },
        dataList: [],
      }
    },
    props: {
      menuId: {
        type: [Number, String],
        default: null
      },
      disabled: Boolean
    },
    watch: {
      menuId: function (newVal, oldVal) {
        this.selectID = newVal;
      },
      selectID : function(newVal, oldVal){
        this.$emit("update:menuId", newVal);
      }
    },
    created() {
      this.getDataList();
    },
    methods: {
      selectOne(event, item) {
        this.$emit('select', event, item);
      },
      getDataList() {
        this.$http({
          url: this.$http.adornUrl('/sys/menu/select'),
          method: 'get',
          params: this.$http.adornParams()
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.dataList = treeDataTranslate(data.menuList)
          } else {
          }
        }).catch((err) => {
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/menu/menu-select.vue